import React, { useEffect } from "react";
import styles from "./styles.module.css";
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Select, Button, Row, Col, message } from "antd";
import { messages } from "../../../../lib/vaildations";
import { useBrand } from "../../../../utils/brandContext";
const { Option } = Select;

const WorkInformation = (props) => {
  const brand = useBrand();
  const { form, nextStep, prevStep, states, workPeriods, data } = props;

  const { getFieldDecorator, setFieldsValue } = form;
  useEffect(() => {
    setFieldsValue({
      ...data,
    });
  }, [data]);

  return (
    <div>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="Work">
            {getFieldDecorator("facilityName", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(
              <Input
                placeholder={
                  brand.SIGN_UP_WORKER_WORK ?? "Where do you currently work?"
                }
              />
            )}
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label="Position">
            {getFieldDecorator("position", {
              rules: [
                {
                  required: true,
                  message: "This field is required!",
                },
              ],
            })(<Input placeholder="Current Position/Title" />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="Work Period">
            {getFieldDecorator("workPeriod", {
              rules: [
                {
                  required: true,
                  message: messages.required,
                },
              ],
            })(
              <Select
                showSearch
                placeholder={
                  brand.SIGN_UP_WORKER_WORK_PERIOD ??
                  "Please Select Work Period"
                }
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {!workPeriods.loading &&
                  workPeriods.data.workPeriods.sort().map((period) => (
                    <Option key={period.id} value={period.sName}>
                      {period.name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label="Facility Street">
            {getFieldDecorator("facilityStreet", {
              // rules: [
              //   {
              //     required: true,
              //     message: messages.required,
              //   },
              // ],
            })(<Input placeholder="Work Street Address?" />)}
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Facility City">
            {getFieldDecorator("city", {
              // rules: [
              //   {
              //     required: true,
              //     message: messages.required,
              //   },
              // ],
            })(<Input placeholder="City" />)}
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item hasFeedback label="Facility State">
            {getFieldDecorator("state", {
              // rules: [{ required: true, message: messages.required }],
            })(
              <Select
                showSearch
                placeholder="Please Select A State"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {!states.loading &&
                  states.data.states.map((state) => (
                    <Option key={state.id} value={state.sName}>
                      {state.name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item label="Facility Zip Code">
            {getFieldDecorator("zipCode", {
              rules: [
                // {
                //   required: true,
                //   message: message.required,
                // },
                {
                  pattern: new RegExp("^([0-9]{5})(?:[-s]*([0-9]{4}))?$"),
                  message: messages.zip,
                },
              ],
            })(<Input placeholder="Zip Code" />)}
          </Form.Item>
        </Col>
      </Row>
      <div className={styles.ButtonsContainer}>
        <Button type="primary" onClick={prevStep}>
          Previous Step
        </Button>
        <Button type="primary" onClick={nextStep}>
          Next Step
        </Button>
      </div>
    </div>
  );
};

export default WorkInformation;
